import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, Lock } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";

export const SuccessScreen = () => (
  <div className="mx-auto max-w-lg px-4 py-16 text-center">
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className="flex justify-center"
    >
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-[color:var(--brand-marsala-soft)]">
        <CheckCircle2 className="h-10 w-10 text-[color:var(--brand-marsala)]" />
      </span>
    </motion.div>
    <h1 className="mt-6 font-serif text-3xl font-semibold text-[color:var(--brand-graphite)]">
      Repertório enviado com sucesso!
    </h1>
    <p className="mt-4 leading-relaxed text-[color:var(--brand-muted)]">
      Recebemos todas as escolhas musicais de vocês. Nossa equipe irá analisar cuidadosamente o
      repertório e entraremos em contato caso seja necessário alinhar algum detalhe.
    </p>

    <div className="mt-8 rounded-2xl border border-[color:var(--brand-border)] bg-white p-6" data-testid="success-locked-card">
      <div className="flex items-center gap-2 text-sm text-[color:var(--brand-muted)]">
        <Lock className="h-4 w-4" /> Repertório enviado
      </div>
      <p className="mt-2 text-sm text-[color:var(--brand-graphite)]">
        Para garantir o controle das escolhas, este repertório não pode mais ser alterado por aqui.
        Precisa ajustar algo? Fale com a equipe da LC Produção — nós liberamos a edição e reenviamos o link para você.
      </p>
    </div>

    <div className="mt-10 flex flex-col items-center gap-2">
      <BrandMark size={44} />
      <p className="font-serif text-lg text-[color:var(--brand-graphite)]">LC Produção</p>
      <p className="text-xs italic text-[color:var(--brand-muted)]">
        Transformando momentos em experiências inesquecíveis.
      </p>
    </div>
  </div>
);
